import {asset} from 'imba';
import url from './problems.png';
export default asset({
	url: url,
	type: 'image',
	width: 1241,
	height: 305,
	toString: function(){ return this.url;}
})